import React from 'react'
import { connect } from 'react-redux'
import { pageLoading } from '../../redux/selectors/pagesSelectors'
import { cartCartSelector } from '../../redux/selectors/cartSelector'
import CurrencyFilterRow from './Parts/CurrencyFilterRow'
import BillsFilterRow from './Parts/BillsFilterRow'

/**
 * Компонент фильтров на странице корзины.
 */

function Filters ({
    cart,
    pageLoading,
    showCurrency = true,
    showBills = true,

}) {

    return (
        <>
            <div className={'section__row'}>
                <ul className={'filter__list'}>
                    {
                        showCurrency && (
                            <CurrencyFilterRow
                                cart={cart}
                                pageLoading={pageLoading}
                            />
                        )
                    }

                    {
                        showBills && (
                            <BillsFilterRow cart={cart}/>
                        )
                    }
                </ul>
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    cart: cartCartSelector(state),
    pageLoading: pageLoading(state)
});

export default connect(mapStateToProps)(Filters)
